import { required, helpers } from 'vuelidate/lib/validators';

const validations = {
    title: {
      required,
    },
    startDate: {
      required,
    },
    endDate: {
      required,
    },
    businessType: {
      required,
    },
    discount: {
      required,
      numeric: helpers.regex('numeric', /^[0-9]*$/),
    },
    code: {
      required,
    },
    limitationUsageNumber: {
      required,
      numeric: helpers.regex('numeric', /^[0-9]*$/),
    },
  };
  
  export default validations;